import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.8rem;
  letter-spacing: 0em;
  text-align: center;

  color: ${({ theme }) => theme.colors.PRIMARY};

  margin-bottom: 1.5rem;

  @media only screen and (min-width: 768px) {
    font-size: 2.2rem;
    line-height: 2.8rem;
  }
`;

export const Board = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  grid-column: span 1;
  background-color: ${({ theme, isImportant = false }) =>
    isImportant ? 'rgba(206, 34, 34, 0.52)' : theme.colors.BOARD};

  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.PRIMARY};
  padding: 1.3rem 1rem;

  margin-bottom: 1.5rem;

  li {
    list-style-type: none;
    font-family: Source Sans Pro;
    font-size: ${({ isSmall }) => (isSmall ? 1.2 : 1.3)}rem;
    font-weight: 400;
    font-style: normal;

    color: ${({ theme, isImportant }) => (isImportant ? theme.colors.WHITE : theme.colors.PRIMARY)};

    span {
      font-family: Source Sans Pro;
      font-size: ${({ isSmall }) => (isSmall ? 1.2 : 1.3)}rem;
      font-style: normal;

      color: ${({ theme, isImportant }) =>
        isImportant ? theme.colors.WHITE : theme.colors.PRIMARY};

      font-weight: 700;

      @media only screen and (min-width: 768px) {
        font-size: 2.2rem;
        line-height: 2.765rem;
      }
    }

    @media only screen and (min-width: 768px) {
      font-size: 2.2rem;
      line-height: 2.765rem;
    }
  }

  li[value='last'] {
    text-align: right;
  }
  word-break: break-word;
`;

export const Line = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0 1.3rem;
  /*
  div:first-child {
    min-width: 10.9rem;
  }
  div:nth-child(2) {
    min-width: 9.8rem;
  }

  div:last-child {
    min-width: 9.6rem;
  }
*/

  @media only screen and (min-width: 768px) {
    div > li,
    div > li > span {
      font-weight: 600;
    }
  }
`;

export const Message = styled.div`
  margin: 3.1rem 0 3.5rem;
  padding: 0 0.5rem;
`;

export const TextModal = styled.span`
  font-family: Source Sans Pro;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;

  color: ${({ theme, isCancel = false }) =>
    isCancel ? theme.colors.IMPORTANT : theme.colors.PRIMARY};

  @media only screen and (min-width: 768px) {
    font-size: 1.8rem;
    line-height: 2.3rem;
  }
`;
